import { useEffect } from "react";

const useTimeoutCleanup = (timeoutRef) => {
  useEffect(() => {
    return () => {
      if (timeoutRef?.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
};

export default useTimeoutCleanup;